var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5542 2.66797C8.52001 2.66797 6.05418 5.1338 6.05418 8.16797V10.8171C6.05418 11.3763 5.81585 12.2288 5.53168 12.7055L4.47751 14.4563C3.82668 15.538 4.27585 16.7388 5.46751 17.1421C9.41835 18.4621 13.6808 18.4621 17.6317 17.1421C18.7408 16.7755 19.2267 15.4646 18.6217 14.4563L17.5675 12.7055C17.2925 12.2288 17.0542 11.3763 17.0542 10.8171V8.16797C17.0542 5.14297 14.5792 2.66797 11.5542 2.66797Z",
    stroke: "#1E1531",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2496 2.93332C12.9654 2.85082 12.6721 2.78665 12.3696 2.74999C11.4896 2.63999 10.6462 2.70415 9.85791 2.93332C10.1237 2.25499 10.7837 1.77832 11.5537 1.77832C12.3237 1.77832 12.9837 2.25499 13.2496 2.93332Z",
    stroke: "#1E1531",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3042 17.4717C14.3042 18.9842 13.0667 20.2217 11.5542 20.2217C10.8025 20.2217 10.1059 19.91 9.61087 19.415C9.11587 18.92 8.8042 18.2233 8.8042 17.4717",
    stroke: "#1E1531",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.f6d71a3cb057d0c1814e6a48a4dbd1fd.svg";
export { ForwardRef as ReactComponent };